import React, { useState, useMemo } from "react";
import { Button, Dropdown, Spinner } from "flowbite-react";
import { Dark } from "../../../../../Theme/Theme";
import "./AddSymbol.css";
import moment from "moment";
import Backend from "../../../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();

export default function Mcx() {
  const [loading, setLoading] = useState(false);
  const [symbol, setSymbol] = useState("");
  const [date, setDate] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  // ==========================
  //   CLEAN DATA ARRAYS
  // ==========================

  const symbols = [
    "GOLD", "GOLDM", "SILVER", "SILVERM", "SILVERMIC",
    "CRUDEOIL", "CRUDEOILM", "NATURALGAS", "NATGASMINI",
    "COPPER", "ZINC", "ZINCMINI", "LEAD", "LEADMINI",
    "ALUMINIUM", "ALUMINI"
  ];

  const dates = useMemo(() => Array.from({ length: 31 }, (_, i) => i + 1), []);
  const months = useMemo(
    () => Array.from({ length: 5 }, (_, i) => moment().add(i, "months").format("MMM")),
    []
  );
  const yearsShort = useMemo(
    () => Array.from({ length: 5 }, (_, i) => moment().add(i, "years").format("YY")),
    []
  );
  const yearsFull = useMemo(
    () => Array.from({ length: 5 }, (_, i) => moment().add(i, "years").format("YYYY")),
    []
  );

  // ==========================
  //   REUSABLE COMPONENT
  // ==========================

  const DropBox = ({ value, setValue, list, displayList, label }) => (
    <div className="nseContainer border-2 border-[var(--hover)]">
      <div className="nseItem label"> {label} : </div>
      <div className="nseItem label">
        <Dropdown
          value={value}
          className="dropDown"
          label={value ? value : `SELECT ${label}`}
          dismissOnClick={true}
          style={{ backgroundColor: Dark.primary }}
        >
          <Dropdown.Item onClick={() => setValue("")}>N/A</Dropdown.Item>
          {list.map((item, i) => (
            <Dropdown.Item key={i} onClick={() => setValue(item)}>
              {displayList ? displayList[i] : item}
            </Dropdown.Item>
          ))}
        </Dropdown>
      </div>
    </div>
  );

  // ==========================
  //  SUBMIT
  // ==========================

  const submit = () => {
    if (!symbol) return toast.error("Select Symbol !");
    if (!month) return toast.error("Select Month !");
    if (!year) return toast.error("Select Year !");

    setLoading(true);

    backend.add_mcx({
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol,
      date: date ? date.toString().padStart(2, "0") : "",
      month,
      year,
    }).then((r) => {
      setLoading(false);
      r.error === "False" ? toast.success(r.message) : toast.error(r.message);
    });
  };

  // ==========================
  //  UI
  // ==========================

  return (
    <div className="flex flex-col justify-center items-center">

      <DropBox label="SYMBOL" value={symbol} setValue={setSymbol} list={symbols} />

      <DropBox label="DATE" value={date} setValue={setDate} list={dates} />

      <DropBox label="MONTH" value={month} setValue={setMonth} list={months} />

      <DropBox
        label="YEAR"
        value={year}
        setValue={setYear}
        list={yearsShort}
        displayList={yearsFull}
      />

      <div style={{ width: 300 }}>
        <Button
          onClick={!loading ? submit : null}
          className="w-full max-w-sm mt-4 text-white font-semibold !bg-[var(--primary)] hover:brightness-90 transition-all rounded-lg flex gap-2 justify-center"
        >
          {loading && <Spinner size="sm" />}
          {!loading && "SUBMIT"}
        </Button>
      </div>
    </div>
  );
}
